// features/notifications/notificationThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import {
  fetchNotificationsByUser,
  markNotificationAsSeen,
} from "../../../services/notificationService";

export const getNotificationsByUser = createAsyncThunk(
  "notifications/getByUser",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await fetchNotificationsByUser(userId);
      // Make sure this returns an array
      return response?.data || [];
    } catch (error) {
      console.error("Error fetching notifications:", error);
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const markAsSeen = createAsyncThunk(
  "notifications/markAsSeen",
  async (notificationId, { rejectWithValue }) => {
    try {
      const response = await markNotificationAsSeen(notificationId);
      toast.success("Notification marked as read");
      return response;
    } catch (error) {
      console.error("Error marking notification as seen:", error);
      toast.error("Failed to mark notification as read");
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);
